export default __webpack_public_path__ + "static/media/1922.4a8cb935.png";